export default __webpack_public_path__ + "static/media/winrate.1bb67d7b.png";